var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"coursework-viewer__slide"},[_c('img',{staticClass:"js-coursework-view__img",class:{'coursework-viewer__grid-pattern': (_vm.media.extension === '.png')},attrs:{"src":_vm.mediaUrl},on:{"load":_vm.ready}})])}
var staticRenderFns = []

export { render, staticRenderFns }